// Takes a non-empty string and returns it with the first letter uppercased
// Empty strings returns empty string
export const capitalize = (str: string): string => {
  if (str.length === 0) return str;

  return str[0].toUpperCase().concat(str.slice(1));
};

// Returns singular or plural form based on count
// Examples:
//   pluralize(1, 'course') => '1 course'
//   pluralize(5, 'course') => '5 courses'
//   pluralize(1, 'category', 'categories') => '1 category'
//   pluralize(3, 'category', 'categories') => '3 categories'
export const pluralize = (count: number, singular: string, plural?: string): string => {
  const word = count === 1 ? singular : (plural ?? `${singular}s`);
  return `${count} ${word}`;
};
